export const SET_SUMMARY_VIEW = 'SET_SUMMARY_VIEW';

export function setView(view) {
  return {
    type: SET_SUMMARY_VIEW,
    payload: view,
  };
}
